import React, { useState } from 'react';
import { useParams } from "react-router-dom";
import { userApi } from '../../../backend_urls/userApi';
import ReusableModal from "../../../components/reusable/ReusableForm";
import LineItems from "../../../components/reusable/LineItems";
import FileUpload from "../../../components/reusable/FileUpload";
import LoadingSpinner from "../../../components/loaders/LoadingSpinner";
import "../../../css/pages/user_pages/modals/ActionCenterModal.css";

const ActionCenterModal = () => {
    const businessId = parseInt(useParams().id, 10);
    // const [businessData, setBusinessData] = useState(null);
    const [loading, setLoading] = useState(false);
    // const [data, setData] = useState([]);
    const [showUploadedFileModal, setShowUploadedFileModal] = useState(false);
    const [uploadedFile, setUploadedFile] = useState([]);
    const [open, setOpen] = useState(false);
    const [lineItems, setLineItems] = useState([
        {
            description: "", quantity: "", taxable_value: "", rate: "",
            igst_amount: "", cgst_amount: "", sgst_amount: "", line_total: "",
        }
    ]);

    // const fetchData = async () => {
    //     try {
    //         setLoading(true);
    //         const res = await userApi.getAllInvoices();
    //         setData(res.data);
    //         const res2 = await userApi.getBusinessDetails(businessId);
    //         setBusinessData(res2.data);
    //     } catch (e) { console.log("Getting error on:", e)
    //     } finally { setLoading(false); }
    // };
    // useEffect(() => { fetchData(); }, [fetchData]);

    const handleExportReports = async () => { await userApi.exportInvoiceGST(businessId); }
    const handleExcelReport = async () => { await userApi.generatExcelFile(businessId)};

    const handleCreateInvoice = () => { setOpen(true); }
    const handleSubmit = async (formData) => {
        setLoading(true);
        const finalPayload = { ...formData, lineItems };
        await userApi.createManualInvoice(finalPayload);
        // fetchData();
        setLoading(false);
        setOpen(false);
    };

    const handleUploadFileDocuments = () => { setShowUploadedFileModal(true); };
    const handleUploadFileChange = (name, files) => { setUploadedFile(files); };
    const handleUploadedFileSave = async () => {
        if (!businessId || isNaN(businessId)) {
            alert("Invalid Business ID. Please check the URL.");
            return;
        }
        if (!uploadedFile || uploadedFile.length === 0) {
            alert("Please select a file");
            return;
        }
        try {
            setLoading(true);
            const uploadDocPromises = uploadedFile.map((file) => {
                const formData = new FormData();
                formData.append("file", file);
                formData.append("business", businessId);
                return userApi.uploadDoc(formData);
            });
            // Wait for all uploads to finish
            await Promise.all(uploadDocPromises);
            setShowUploadedFileModal(false);
        } catch (e) { console.log("Error uploading file:", e);
        } finally { setLoading(false); };
    };

    return ( loading ? <LoadingSpinner /> :
        <>
            <div className="quick-actions">
                <button
                    className="action-btn gradient-1"
                    onClick={handleCreateInvoice}
                >
                    <div className="icon-box">📄</div>
                    <div className="btn-subtext">Create Manual Invoice</div>
                    <div className="btn-text">Draft and issue invoices</div>
                </button>

                <button
                    className="action-btn gradient-2"
                    onClick={handleUploadFileDocuments}
                >
                    <div className="icon-box">⬆️</div>
                    <div className="btn-subtext">Upload Documents</div>
                    <div className="btn-text">Import files & records</div>
                </button>

                <button
                    className="action-btn gradient-3"
                    onClick={handleExportReports}
                >
                    <div className="icon-box">⬇️</div>
                    <div className="btn-subtext">Export Reports</div>
                    <div className="btn-text">Download analytics data</div>
                </button>
                <button
                    className="action-btn gradient-3"
                    onClick={handleExcelReport}
                >
                    <div className="icon-box">⬇️</div>
                    <div className="btn-subtext">Generate Excel Report</div>
                </button>
            </div>

            <ReusableModal
                isOpen = { open }
                onClose = { () => setOpen(false) }
                title = "Create Invoice"
                onSubmit = { handleSubmit }
                fields={[
                    { name: "seller_name", label: "Seller Name", required: true },
                    { name: "seller_gstin", label: "Seller GST Number", required: true },
                    { name: "buyer_name", label: "Buyer Name", required: true },
                    { name: "buyer_gstin", label: "Buyer GST Number", required: true },
                    { name: "invoice_number", label: "Invoice Number", required: true },
                    { name: "invoice_date", label: "Date", type: "date", required: true },
                    { name: "place_of_supply_code", label: "Place of Supply Code", required: true },
                    { name: "grand_total", label: "Total Amount Spend", required: true },
                ]}
            >
                {/* 🔥 Inject dynamic UI */}
                <LineItems
                    lineItems = { lineItems }
                    setLineItems = { setLineItems }
                />
            </ReusableModal>

            {/* Upload Document component */}
            {showUploadedFileModal && (
                <FileUpload
                    name = "document"
                    label = "Upload Your File"
                    acceptType = "both"
                    maxFiles={100}      // Enable multi-file selection (up to 100)
                    maxSizeMB={10}      // Set max file size to 10MB
                    onChange = { handleUploadFileChange }
                    onSave = { handleUploadedFileSave }
                    onClose = { () => setShowUploadedFileModal(false) }
                />
            )}
        </>
    );
};

export default ActionCenterModal;
